<template lang="pug">
	.vimeo-wrapper(ref="container")
		iframe(
			:src="url"
			:width="containerWidth"
			:height="containerHeight"
			frameborder="0"
			allow="autoplay; fullscreen"
			allowfullscreen
			:style="{'height': containerHeight + 'px'}"
		)
</template>
<script>
//import Components
import _ from 'lodash'

export default {
	name: "YouTube",
	components: {
    },
    data() {
    	return {
    		containerWidth: undefined,
    		containerHeight: undefined
    	}
    },
	props: {
		video: {
			type: Object,
			required: true
		}
	},
	computed: {
		url() {
			return 'https://player.vimeo.com/video/' + this.video.title
		}
	},
	mounted() {
		const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.containerWidth = this.$refs.container.clientWidth
                this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                this.containerHeight = this.$refs.container.clientHeight
                this.containerWidth -= parseFloat(style.paddingTop) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
	}
}
</script>
<style lang="sass" scoped>
	@import "~bulma/sass/utilities/mixins";
	.vimeo-wrapper
		position: relative
		width: 100%
		height: 100%
		min-height: 350px
		+tablet
			min-height: 350px
</style>